import { Handle, Position, useNodeConnections, useConnection } from '@xyflow/react';

const SOURCE_HANDLE_STYLE = {
  background: 'blue',
  borderRadius: 0,
  border: 'none',
  opacity: 0,
};

const TARGET_HANDLE_STYLE = {
  ...SOURCE_HANDLE_STYLE,
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  transform: 'none',
};

const HANDLE_THICKNESS = 3;

function DefaultHandles({ id, width, height, isConnectable }) {
  const connection = useConnection();

  const isTarget = connection.inProgress && connection.fromNode.id !== id;

  return (
    <>
      {/* If handles are conditionally rendered and not present initially, you need to update the node internals https://reactflow.dev/docs/api/hooks/use-update-node-internals/ */}
      {/* In this case we don't need to use useUpdateNodeInternals, since !isConnecting is true at the beginning and all handles are rendered initially. */}
      {!connection.inProgress && (
        <>
          <Handle
            style={{
              ...SOURCE_HANDLE_STYLE,
              width: HANDLE_THICKNESS,
              height: '100%',
            }}
            position={Position.Left}
            isConnectable={isConnectable}
            type="source"
          />
          <Handle
            style={{
              ...SOURCE_HANDLE_STYLE,
              width: '100%',
              height: HANDLE_THICKNESS,
            }}
            position={Position.Top}
            isConnectable={isConnectable}
            type="source"
          />
          <Handle
            style={{
              ...SOURCE_HANDLE_STYLE,
              width: HANDLE_THICKNESS,
              height: '100%',
              marginLeft: width - 2 * HANDLE_THICKNESS,
            }}
            position={Position.Right}
            isConnectable={isConnectable}
            type="source"
          />
          <Handle
            style={{
              ...SOURCE_HANDLE_STYLE,
              width: '100%',
              height: HANDLE_THICKNESS,
              marginTop: height - 2 * HANDLE_THICKNESS,
            }}
            position={Position.Bottom}
            isConnectable={isConnectable}
            type="source"
          />
        </>
      )}
      {/* We want to disable the target handle, if the connection was started from this node */}
      {(!connection.inProgress || isTarget) && <Handle style={TARGET_HANDLE_STYLE} type="target" isConnectableStart={false} />}
    </>
  );
}

export default DefaultHandles;
